import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Home from '@/pages/Home';
import Projects from '@/pages/Projects';
import ProjectDetail from '@/pages/ProjectDetail';
import Builders from '@/pages/Builders';
import BuilderDetail from '@/pages/BuilderDetail';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminLayout from '@/components/admin/AdminLayout';
import AdminOverview from '@/pages/admin/AdminOverview';
import AdminProperties from '@/pages/admin/AdminProperties';
import AdminLeads from '@/pages/admin/AdminLeads';
import ProtectedRoute from '@/components/ProtectedRoute';
import StickyCTA from '@/components/StickyCTA';

// Wrapper to conditionally render StickyCTA
const AppContent = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/builders" element={<Builders />} />
        <Route path="/builders/:builder" element={<BuilderDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        
        {/* Admin Login (Public) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        
        {/* Admin Routes (Protected) */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<AdminOverview />} />
          <Route path="properties" element={<AdminProperties />} />
          <Route path="leads" element={<AdminLeads />} />
        </Route>
      </Routes>
      
      {/* Only show StickyCTA on non-admin routes */}
      {!isAdminRoute && <StickyCTA />}
    </>
  );
};

function App() {
  return (
    <>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </>
  );
}

export default App;
// redeploy trigger
